import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button } from "nq-component";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import PayrollTtypeFormPage from "./payroll-type-assign-form/PayrollTypeAssignFormPage";
import InputFactory from "../../../components/InputFactory";
import PayrollTypeAssignPresenter from "./PayrollTypeAssignPresenter";

class PayrollTypeAssignPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      objects: [],
      selectedEarnings: "",
      selectedPayrollType: "",
      isAssignModal: false,
      selected: [],
      employeeData: [],
      mode: "",
      limit: 50,
      current: 1,
      count: 0,
    };
    this.presenter = new PayrollTypeAssignPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "employees";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async handleAddPayroll() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  async handleDeleteData(data) {
    await this.presenter.deleteObjectUseCase.execute("payroll_type", data.id);
    this.refetchData();
  }

  async handleEditData(employeeData) {
    this.setState({ isAssignModal: true, employeeData, mode: "edit" });
  }

  async handleSelectChange(value, field) {
    this.setState({ [field]: value });
  }

  async handleAssign() {
    if (!this.state.selected.length > 0) {
      this.showError("No selected Employees.");
      return;
    }

    this.setState({ isAssignModal: true });
  }

  async confirmChanges() {
    return this.presenter.getconfirmChanges();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  logSelectedEntries(params) {
    return this.presenter.setSelectedEntries(params);
  }

  handleCloseModal() {
    this.setState({ isAssignModal: false });
  }

  handleSuccess() {
    this.showSuccess("Data successfully saved! ");
  }

  render() {
    const {
      objects,
      loading,
      selected,
      count,
      limit,
      current,
      isAssignModal,
      employeeData,
    } = this.state;

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "employmentType" &&
        fields !== "payrollRelation"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} ReferenceTable {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Payroll Type
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                 <div className="row p-1">
                  {Object.keys(schema.filters || {})
                    .filter(
                      (field) =>
                        ![
                          "earnings",
                          "sex",
                          "civil",
                          "month",
                          "year",
                          "lengthOfService",
                          "employmentType",
                        ].includes(field)
                    )
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>

                <div className="row">
                  {Object.keys(schema.filters || {})
                    .filter((field) => field === "classification")
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 mt-3" key={field}>
                          <InputFactory
                            type={type}
                            field={field}
                            where={{}}
                            onChange={(val) =>
                              this.presenter._onChangeFilter(type, val, field)
                            }
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center  justify-content-center">
                    <h4 className="text-primary">Payroll Type Assign</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <div className="p-0">
                        <Button onClick={this.handleAssign.bind(this)}>
                        <i class="bi bi-check2-circle"></i> Assign
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this.handleDeleteData.bind(this)}
                editPayrollType={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                selectable
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "Payroll Type",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                selected={selected}
                onSelect={(value) => this.presenter.onSelect(value)}
                onSelectAll={this.onSelectAll.bind(this)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {isAssignModal && (
          <PayrollTtypeFormPage
            selected={selected}
            refetchData={this.refetchData.bind(this)}
            closeModal={this.handleCloseModal.bind(this)}
            savedData={this.handleSuccess.bind(this)}
            employeeData={employeeData}
            mode={this.state.mode}
          />
        )}
      </>
    );
  }
}

export default PayrollTypeAssignPage;
